<!-- <div class="row" *ngIf="!AddEditMedia">
  <div class="col-md-12">
    <ul class="cEntityAdd" (click)="AddMedia()">
      <li>
        <a class="cEntityAddBg">
          <i class="fa fa-plus" aria-hidden="true"></i>
          <span>Add media</span>
        </a>
      </li>
    </ul>
  </div>
</div> -->
<!-- <div class="row table-responsive" hidden *ngIf="!AddEditMedia && Session">
  <div class="col-lg-12">
    <div class="cDivTable">
      <mat-toolbar class="cTableHeader">Uploaded media</mat-toolbar>
      <ManikLoader *ngIf="manikLoadingResults"></ManikLoader>
      <div class="manik-table-container" *ngIf="!manikLoadingResults">
        <table mat-table [dataSource]="DataTable" *ngIf="DataTable.data.length && !IsEmptyGrid;else noRecord;"
          class="table table-hover table-bordered table-striped">
          <ng-container matColumnDef="MediaHeader">
            <th mat-header-cell *matHeaderCellDef>Header</th>
            <td mat-cell *matCellDef="let row">{{row.MediaHeader}}</td>
          </ng-container>
          <ng-container matColumnDef="MediaURL">
            <th mat-header-cell *matHeaderCellDef width="20%">Preview</th>
            <td mat-cell *matCellDef="let row">
              <img *ngIf="row.MediaType == 'I'" [src]="row.MediaURL" height="100" width="100%">
              <video *ngIf="row.MediaType == 'V'" [src]="row.MediaURL" width="100%" height="100"></video>
              <iframe *ngIf="row.MediaType == 'Y'" [src]="row.YtURL" width="100%" height="100"></iframe>
            </td>
          </ng-container>
          <ng-container matColumnDef="MediaType">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let row">
              <div *ngIf="row.MediaType == 'I'">
                Image
              </div>
              <div *ngIf="row.MediaType == 'V'">
                Video
              </div>
              <div *ngIf="row.MediaType == 'Y'">
                Youtube video
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="BusinessImageID">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row;">
              <button class="cTooltipEditText" (click)="EditMedia(row.BusinessImageID)"></button>
              <button class="cTooltipDeleteText" (click)="DeleteMedia(row.BusinessImageID)"></button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <ng-template #noRecord>
          <div class="row">
            <label class="manik-no-rec">No Record Found</label>
          </div>
        </ng-template>
      </div>
      <mat-paginator [length]="PageLength" [pageSize]="PageSize" [pageSizeOptions]="PageSizeOptions"
        (page)="manikGridViewPagination()" showFirstLastButtons class="manik-pagination"></mat-paginator>
    </div>
  </div>
</div> -->
<!-- <form [formGroup]="candidForm" [hidden]="!AddEditMedia" *ngIf="Session">
  <div class="row">
    <div class="col-md-6">
      <div class="cMatdd_main"
        [ngClass]="{'cMatdd_erorr': f.MediaType.invalid && (f.MediaType.touched || submitted),
        'cSuccess': f.MediaType.valid && f.MediaType.dirty}">
        <h5>Media type</h5>
        <mat-select formControlName="MediaType" (selectionChange)="RefreshFile()" placeholder="Select a media type">
          <mat-option value="I">Image</mat-option>
          <mat-option value="V">Video</mat-option>
          <mat-option value="Y">Youtube url</mat-option>
        </mat-select>
        <span *ngIf="f.MediaType.errors && submitted" class="cErrorMsg">
          <span *ngIf="f.MediaType.errors.required">
            Please select a media type
          </span>
        </span>
      </div>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-4" [hidden]="f.MediaType.value == ''">
      <div class="cSimpleUpload" [hidden]="f.MediaType.value != 'I'">
        <img id="CandidPhoto" />
        <span class="image-upload">
          <label for="candid-photo-upload">
            <i class="fa fa-upload" aria-hidden="true"></i>
          </label>
          <input type="file" id="candid-photo-upload" (change)="imgPreview($event,'CandidPhoto',1)">
        </span>
      </div>
      <div class="cSimpleUpload" [hidden]="f.MediaType.value != 'V'">
        <video controls="controls" id="iCvideo" width="320" height="240">
          <source type="video/mp4" class="cvideo" />
          <source type="video/webm" class="cvideo" />
          <source type="video/ogg" class="cvideo" />
        </video>
        <span class="image-upload">
          <label for="candid-video-upload">
            <i class="fa fa-upload" aria-hidden="true"></i>
          </label>
          <input type="file" id="candid-video-upload" (change)="videoSetup($event, 1, 'cvideo', 'iCvideo')">
        </span>
      </div>
      <div class="cDefault" [hidden]="f.MediaType.value != 'Y'">
        <h5>Video URL</h5>
        <input type="text" formControlName="VideoURL" (blur)="VideoURLBlur(CandidForm.VideoURL)">
        <iframe *ngIf="SanitizedURL" [src]="SanitizedURL" width="320" height="240"></iframe>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div class="cMatdd_main"
        [ngClass]="{'cMatdd_erorr': f.MediaTagType.invalid && (f.MediaTagType.touched || submitted),'cSuccess': f.MediaTagType.valid && f.MediaTagType.dirty}">
        <h5>Media tag type</h5>
        <mat-select formControlName="MediaTagType" placeholder="Select the tag type">
          <mat-option *ngFor="let item of MediaTagTypeList" [value]="item.DataValue">{{item.DataText}}</mat-option>
        </mat-select>
        <span *ngIf="f.MediaTagType.errors && submitted" class="cErrorMsg">
          <span *ngIf="f.MediaTagType.errors.required">
            Please enter media tag
          </span>
        </span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div class="cDefault"
        [ngClass]="{'cErorr': f.MediaHeader.invalid && (f.MediaHeader.touched || submitted),'cSuccess': f.MediaHeader.valid && f.MediaHeader.dirty}">
        <h5>Media header</h5>
        <input type="text" formControlName="MediaHeader">
        <span *ngIf="f.MediaHeader.errors && submitted" class="cErrorMsg">
          <span *ngIf="f.MediaHeader.errors.required">
            Please enter media header
          </span>
        </span>
      </div>
    </div>
  </div>
  <div class="cDivAction">
    <button type="button" class="cButtonCancel" (click)="cancel()"></button>
    <button class="cButtonSubmit" (click)="SendToDB()"></button>
  </div>
</form> -->
<form [formGroup]="candidForm" [hidden]="!AddEditMedia" *ngIf="Routes">
  <div class="row">
    <div class="col-md-8">
      <div class="row">
        <div class="col-md-4">
          <div class="cMatdd_main"
            [ngClass]="{'cMatdd_erorr': f.MediaType.invalid && (f.MediaType.touched || submitted),'cSuccess': f.MediaType.valid && f.MediaType.dirty}">
            <h5>Media type</h5>
            <mat-select formControlName="MediaType" (selectionChange)="RefreshFile()" placeholder="Select a media type">
              <mat-option value="I">Image</mat-option>
              <mat-option value="V">Video</mat-option>
              <mat-option value="Y">Youtube url</mat-option>
            </mat-select>
            <span *ngIf="f.MediaType.errors && submitted" class="cErrorMsg">
              <span *ngIf="f.MediaType.errors.required">
                Please select a media type
              </span>
            </span>
          </div>
        </div>
        <div class="col-md-4">
          <div class="cMatdd_main"
            [ngClass]="{'cMatdd_erorr': f.MediaTagType.invalid && (f.MediaTagType.touched || submitted),'cSuccess': f.MediaTagType.valid && f.MediaTagType.dirty}">
            <h5>Media tag type</h5>
            <mat-select formControlName="MediaTagType" placeholder="Select the tag type">
              <mat-option *ngFor="let item of MediaTagTypeList" [value]="item.DataValue">{{item.DataText}}</mat-option>
            </mat-select>
            <span *ngIf="f.MediaTagType.errors && submitted" class="cErrorMsg">
              <span *ngIf="f.MediaTagType.errors.required">
                Please enter media tag
              </span>
            </span>
          </div>
        </div>
        <div class="col-md-2"></div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="cDefault"
            [ngClass]="{'cErorr': f.MediaHeader.invalid && (f.MediaHeader.touched || submitted),'cSuccess': f.MediaHeader.valid && f.MediaHeader.dirty}">
            <h5>Media header</h5>
            <input type="text" formControlName="MediaHeader">
            <span *ngIf="f.MediaHeader.errors && submitted" class="cErrorMsg">
              <span *ngIf="f.MediaHeader.errors.required">
                Please enter media header
              </span>
            </span>
          </div>
        </div>
        <div class="col-md-4"></div>
        <div class="col-md-2"></div>
      </div>
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-10">
          <div class="cDivAction">
            <button type="button" class="cButtonCancel" (click)="cancel()"></button>
            <button class="cButtonSubmit" (click)="SendToDB()"></button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="row">
        <div class="col-md-10" [hidden]="f.MediaType.value == ''">
          <div class="cSimpleUpload" [hidden]="f.MediaType.value != 'I'">
            <img height="320" id="CandidPhoto" />
            <span class="image-upload">
              <label for="candid-photo-upload">
                <i class="fa fa-upload" aria-hidden="true"></i>
              </label>
              <input type="file" id="candid-photo-upload" (change)="imgPreview($event,'CandidPhoto',1)">
            </span>
          </div>
          <div class="cSimpleUpload" [hidden]="f.MediaType.value != 'V'">
            <video controls="controls" id="iCvideo" width="320" height="240">
              <source type="video/mp4" class="cvideo" />
              <source type="video/webm" class="cvideo" />
              <source type="video/ogg" class="cvideo" />
            </video>
            <span class="image-upload">
              <label for="candid-video-upload">
                <i class="fa fa-upload" aria-hidden="true"></i>
              </label>
              <input type="file" id="candid-video-upload" (change)="videoSetup($event, 1, 'cvideo', 'iCvideo')">
            </span>
          </div>
          <div class="cDefault" [hidden]="f.MediaType.value != 'Y'">
            <h5>Video URL</h5>
            <input type="text" formControlName="VideoURL" (blur)="VideoURLBlur(CandidForm.VideoURL)">
            <iframe *ngIf="SanitizedURL" [src]="SanitizedURL" width="320" height="240"></iframe>
          </div>
        </div>
        <div class="col-md-2"></div>
      </div>
    </div>
  </div>
</form>
<!-- <div class="row" *ngIf="!AddEditMedia && Session">
  <div class="col-md-8" *ngFor="let d of data">
    <img *ngIf="d.MediaType == 'I'" [src]="d.MediaURL" height="150" width="100%">
    <video controls="controls" *ngIf="d.MediaType == 'V'" [src]="d.MediaURL" width="100%" height="150">
      <source type="video/mp4" class="cvideo" />
      <source type="video/webm" class="cvideo" />
      <source type="video/ogg" class="cvideo" />
    </video>
    <iframe *ngIf="d.MediaType == 'Y'" [src]="d.YtURL" width="100%" height="150"></iframe>
    <button class="cTooltipEditText" (click)="EditMedia(d.BusinessImageID)"></button>
    <button class="cTooltipDeleteText" (click)="DeleteMedia(d.BusinessImageID)"></button>
  </div>
</div> -->

<!-- <div class="row" *ngIf="Routes && !AddEditMedia">
  <div class="col-md-3" *ngFor="let d of data">
    <img *ngIf="d.MediaType == 'I'" [src]="d.MediaURL" width="100%" height="200">
    <video controls="controls" *ngIf="d.MediaType == 'V'" [src]="d.MediaURL" width="100%" height="200">
      <source type="video/mp4" class="cvideo" />
      <source type="video/webm" class="cvideo" />
      <source type="video/ogg" class="cvideo" />
    </video>
    <iframe *ngIf="d.MediaType == 'Y'" [src]="d.YtURL" width="100%" height="200"></iframe>
    <button class="cTooltipEditText" (click)="EditMedia(d.BusinessImageID)"></button>
    <button class="cTooltipDeleteText" (click)="DeleteMedia(d.BusinessImageID)"></button>
  </div>
</div> -->